module.exports = __webpack_public_path__ + "img/8.12672271.png";